import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BarcodeService {
  constructor() {}

  public ToExpireDate(value: string | undefined): string | undefined {
    if (value == undefined) {
      return undefined;
    }

    const regexBarcode: RegExp =
      /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
    if (regexBarcode.test(value)) {
      const groups = value.match(regexBarcode)?.groups;
      const expireDate: string = String(groups?.['exp']);

      const regexExpDate: RegExp =
        /(?<year>\d{2})(?<month>\d{2})(?<day>\d{0,2})/;
      if (regexExpDate.test(expireDate)) {
        const expiregroups = expireDate.match(regexExpDate)?.groups;

        const year: number = Number(expiregroups?.['year']);
        const month: string = String(expiregroups?.['month']);
        let day: string = String(expiregroups?.['day']);
        if (day == null || day == '' || day == '00') {
          day = '01';
        }

        return `20${year}-${month}-${day}T12:00:00`;
      }
    }

    const uniqueRegexBarcode: RegExp =
      /^02\|(?<drugId>[0-9A-Fa-f]{8}\-[0-9A-Fa-f]{4}\-[0-9A-Fa-f]{4}\-[0-9A-Fa-f]{4}\-[0-9A-Fa-f]{12})\|(?<year>\d{4})(?<month>\d{1,2})(?<day>\d{0,2})$/;
    if (uniqueRegexBarcode.test(value)) {
      const groups = value.match(uniqueRegexBarcode)?.groups;
      const year: number = Number(groups?.['year']);
      const month: string = String(groups?.['month']);
      let day: string = String(groups?.['day']);
      if (day == null || day == '' || day == '00') {
        day = '01';
      }

      return `${year}-${month}-${day}T12:00:00`;
    }

    return undefined;
  }

  public ToLOT(value: string | undefined): string | undefined {
    if (value == undefined) {
      return undefined;
    }

    const regexBarcode: RegExp =
      /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
    if (regexBarcode.test(value)) {
      const groups = value.match(regexBarcode)?.groups;
      return String(groups?.['lot']);
    }

    return undefined;
  }

  public ToGTN(value: string | undefined): string | undefined {
    if (value == undefined) {
      return undefined;
    }

    const regexBarcode: RegExp =
      /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
    if (regexBarcode.test(value)) {
      const groups = value.match(regexBarcode)?.groups;
      return String(groups?.['GTN']);
    }

    return undefined;
  }

  
  public ToDugId(value: string | undefined): string | undefined {
    if (value == undefined) {
      return undefined;
    }

    const uniqueRegexBarcode: RegExp =
      /^02\|(?<drugId>[0-9A-Fa-f]{8}\-[0-9A-Fa-f]{4}\-[0-9A-Fa-f]{4}\-[0-9A-Fa-f]{4}\-[0-9A-Fa-f]{12})\|(?<year>\d{4})(?<month>\d{1,2})(?<day>\d{0,2})$/;
    if (uniqueRegexBarcode.test(value)) {
      const groups = value.match(uniqueRegexBarcode)?.groups;

      return String(groups?.['drugId']);
    }

    return undefined;
  }

  public ToUID(value: string | undefined): string | undefined {
    if (value == undefined) {
      return undefined;
    }

    const regexBarcode: RegExp =
      /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
    if (regexBarcode.test(value)) {
      const groups = value.match(regexBarcode)?.groups;
      return String(groups?.['UID']);
    }

    return undefined;
  }
}
